module.exports = __webpack_public_path__ + "images/category_lp/common/reason2-shared_31868ca2b2ba1544e3e33ce194da40a4.jpg";